module.exports = __webpack_public_path__ + "img/1210-fair.079ec793.png";